export const USER_GROUPS = {
    ADMIN: '5b6a9ee2ba52006858939023',
    TRANSPORT_MANAGEMENT: '67fe36c7824ec0fc7501d885',
};



// WEBPACK FOOTER //
// ./src/common/constants/userGroups.js